import { useState } from "react";
import {
  GetTeacherInformation,
  GetSchoolDataBySchoolId,
  GetStudentInfoByStudentId,
} from "../../actions/teacherQueries";
import { Row, Col, Card, CardBody } from "reactstrap";
import Pacmanloader from "../../components/Pacmanloader/Pacmanloader";
import DataLoadError from "../../components/DataLoadError/DataLoadError";
import TeacherAdmin from "../../components/Teacher/Tabs/TeacherAdmin";
import TeacherResultOverview from "../../components/Teacher/Tabs/TeacherResultOverview";
import TeacherDocuments from "../../components/Teacher/Tabs/TeacherDocuments";
import TeacherCourses from "../../components/Teacher/Tabs/TeacherCourses";
import TabNavSelector from "../../components/Teacher/Tabs/TabNavSelector";
import APL from "../../components/APL/APL";
import useTeacherNavStore from "../../stores/useTeacherNavStore";
import { useParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

function TeacherStudent() {
  const { studentId, programId } = useParams();
  const [toggleEditModal, setToggleEditModal] = useState(false);
  const [updated, setUpdated] = useState(false);
  const queryClient = useQueryClient();
  const studentInfo = GetStudentInfoByStudentId(studentId);
  const teacherInfo = GetTeacherInformation();
  const schoolInfo = GetSchoolDataBySchoolId(
    teacherInfo.isSuccess ? teacherInfo.data.customer.id : null
  );

  const tab = useTeacherNavStore((state) => state.tab);
  const editToggleEditModal = () => {
    setToggleEditModal(!toggleEditModal);
  };
  const updateStore = () => {
    queryClient.invalidateQueries({ queryKey: ["FetchTeacherInformation"] });
    queryClient.invalidateQueries({ queryKey: ["FetchStudentInfoByStudentId", studentId] });
    setUpdated(!updated);
  };

  if (studentInfo.isError || teacherInfo.isError || schoolInfo.isError) {
    return <DataLoadError />;
  }

  if (teacherInfo.isPending || studentInfo.isPending) {
    return <Pacmanloader />;
  }

  let teacherClasses = [];

  teacherInfo.data.programmes.forEach((programme) => {
    programme.classes.forEach((clas) => {
      teacherClasses.push(clas);
    });
  });

  const renderTab = () => {
    switch (tab) {
      case 1:
        return (
          <TeacherAdmin
            level="Student"
            studentId={studentId}
            key={studentInfo.data.id + " " + updated}
            student={studentInfo.data}
            studentHasLicense={studentInfo.data.licenses.length > 0}
            toggleEdit={editToggleEditModal}
            isOpen={toggleEditModal}
            updateStudents={updateStore}
            classes={teacherClasses}
            school={teacherInfo.data.customer}
            teacherInfo={teacherInfo}
            schoolInfo={schoolInfo}
          />
        );
      case 2:
        return (
          <TeacherCourses
            level="Student"
            objId={"student" + studentId}
            studentId={studentId}
            teacherInfo={teacherInfo}
            displayDocuments={false}
          />
        );
      case 3:
        return (
          <TeacherResultOverview
            level="Student"
            studentHasLicense={studentInfo.data.licenses.length > 0}
            studentId={studentId}
            student={studentInfo.data}
          />
        );
      case 5:
        return <TeacherDocuments level="Student" />;
      case 7:
        return (
          <APL
            levelName={[studentInfo.data.name]}
            students={[studentInfo.data]}
            level={"Student"}
            objId={studentInfo.data.id}
            schoolId={teacherInfo.data.customer.id}
            programId={programId}
            teacherInfo={teacherInfo}
          />
        );
      default:
        return <TeacherAdmin level="Student" />;
    }
  };

  return (
    <div className="teacher-container animated fadeIn">
      <Row>
        <Col lg={12}>
          <Card>
            <TabNavSelector level={"Student"} objId={studentId} />
            <CardBody className="responsive-card">{renderTab()}</CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default TeacherStudent;
